import { render, staticRenderFns } from "./Uri.vue?vue&type=template&id=d816011a&"
import script from "./Uri.vue?vue&type=script&lang=js&"
export * from "./Uri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports